import actionTypes from '../actionTypes';

export function toggleAvailableGamesList() {
  return {
    type: actionTypes.TOGGLE_AVAILABLE_GAMES_LIST,
  };
}

export function changeGameBoxView(payload: string) {
  return {
    type: actionTypes.CHANGE_GAME_BOX_VIEW,
    payload
  };
}

export function changeKycStatus(payload: string | undefined | null) {
  return {
    type: actionTypes.CHANGE_GAME_BOX_KYC,
    payload
  };
}

export function changeLimitsStatus(payload: boolean) {
  return {
    type: actionTypes.CHANGE_GAME_BOX_LIMITS,
    payload
  };
}

export function toggleRaffleDrawRules() {
  return {
    type: actionTypes.TOGGLE_RAFFLE_DRAW_RULES,
  };
}

export function setRaffleDrawView(value: string) {
  return {
    type: actionTypes.SET_RAFFLE_DRAW_VIEW,
    value
  };
}